import React from "react";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import { utcTimeAgo } from "../../../utils/utcTime";

// Builds the panel's contextual message: "You submitted your responses to the same
// {Template} VQQ to {Past Sponsor} {time ago}. Autorelease accepts ... — all in one click.
// Click here to view and verify your last submitted responses."
const AutoreleaseContextMessage = ({
  templateName,
  selectedPast,
  onViewLastSubmitted,
  returnToId,
}) => {
  if (!selectedPast) return null;

  const sponsor = selectedPast.sponsor_name || "another sponsor";
  const ago = utcTimeAgo(selectedPast.release_date);
  // The Details route is keyed on the HC questionnaire_id (int), not the SponsorRFIResponse
  // Guid PK. past_submissions are filtered server-side to have questionnaire_id != null, so
  // this is always present.
  const pastDetailsPath = returnToId
    ? `/RFI/${selectedPast.questionnaire_id}/Details?returnTo=${returnToId}`
    : `/RFI/${selectedPast.questionnaire_id}/Details`;

  return (
    <div className="flex items-start gap-3 text-sm text-gray-800">
      <InformationCircleIcon
        className="h-5 w-5 text-indigo-500 shrink-0 mt-0.5"
        aria-hidden="true"
      />
      <p className="leading-relaxed">
        You submitted your responses to the same{" "}
        <Link
          to={pastDetailsPath}
          className="text-indigo-700 underline font-medium hover:text-indigo-800"
        >
          {templateName || "Diligent"} VQQ to {sponsor} {ago}
        </Link>
        . Autorelease accepts the sponsor's qualification questionnaire request,
        populates it with your last approved and submitted responses, and submits
        the auto-completed VQQ to the sponsor — all in one click.{" "}
        <button
          type="button"
          onClick={onViewLastSubmitted}
          className="text-indigo-700 underline font-medium hover:text-indigo-800 italic"
        >
          Click here to view and verify your last submitted responses.
        </button>
      </p>
    </div>
  );
};

export default AutoreleaseContextMessage;
